import React from 'react';
import { HashLinkPathsIds } from '../../../Routing/HashLinkPathIds';
import { useTranslation } from 'react-i18next';
import { scrollWithOffset } from '../../../Common/Utils/scroller';
import { Path } from '../../../Routing';
import { StyledHashLink, Header } from './sharedStyles';

const BenefitLinks: React.FC = () => {
  const { t } = useTranslation();

  const handleOffset = (element: Element) => scrollWithOffset(element, -200);

  return (
    <>
      <Header>{t('footer.ourBenefits')}</Header>
      <StyledHashLink
        to={Path.Revenue}
        scroll={handleOffset}
        elementId={HashLinkPathsIds.Root}
        smooth
      >
        {t('footer.monetization')}
      </StyledHashLink>
      <StyledHashLink
        to={Path.Loyalty}
        scroll={handleOffset}
        elementId={HashLinkPathsIds.Root}
        smooth
      >
        {t('footer.loyalty')}
      </StyledHashLink>
      <StyledHashLink
        to={Path.ESG}
        scroll={handleOffset}
        elementId={HashLinkPathsIds.Root}
        smooth
      >
        {t('footer.esg')}
      </StyledHashLink>
    </>
  );
};

export default BenefitLinks;
